import { render, staticRenderFns } from "./SeminarReviews.vue?vue&type=template&id=2ad7352f&"
import script from "./SeminarReviews.vue?vue&type=script&lang=js&"
export * from "./SeminarReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports